import styled from 'styled-components';

export const Content = styled.div`
  .ant-tabs-nav {
    margin-bottom: 16px;
  }
  .fc-header-toolbar .fc-toolbar-chunk {
    &,
    .fc-button-group {
      button {
        background-color: transparent !important;
        border: none !important;
        outline: none !important;
        border-radius: 0 !important;
        color: #2552f3 !important; // TODO: theme
        border-bottom: 2px solid transparent !important;
        &:focus {
          box-shadow: none !important;
        }
      }
    }
    .fc-button-group {
      &:last-child {
        button.fc-button-active {
          border-bottom: 2px solid #2552f3 !important; // TODO: theme
        }
      }
    }
  }
  .fc-timegrid-slots
    table
    tbody
    tr:first-child
    .fc-timegrid-slot-label-cushion {
    display: none;
  }
  .fc-scrollgrid {
    border: none !important;
  }

  .fc-scrollgrid td:last-of-type {
    border-right: none !important;
  }

  .fc-theme-standard th:last-child {
    border-right: none !important;
  }
  td {
    position: relative;
  }
  .fc-timegrid-slot-label-cushion {
    position: absolute;
    right: 0;
    top: -50%;
    background-color: #f7f8fb; // TODO: theme
  }
  .fc-col-header-cell-cushion {
    color: #000000;
  }
  .fc-day-today {
    background-color: transparent !important;
    .fc-col-header-cell-cushion {
      color: #2552f3 !important; // TODO: theme
    }
  }
  .fc .fc-toolbar.fc-header-toolbar {
    margin-bottom: 32px !important;
  }
`;
